import { render, staticRenderFns } from "./termsModal.vue?vue&type=template&id=7c9e18c7&"
import script from "./termsModal.vue?vue&type=script&lang=js&"
export * from "./termsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports